import { Injectable } from "@angular/core";
import { Subject } from "rxjs";
import { OtherDetailService } from '../data/other-detail.service';


@Injectable({
  providedIn: 'root'
})
export class CaptchaV3UIService {

  private captchaClientApiBaseUrl = 'https://www.google.com/recaptcha/api.js';
  private siteKey = '';
  private isCaptchaLoaded: Boolean = false;
  private scriptId;
  private action;

  public CaptchaTokenSubject = new Subject<string>();

  public constructor(private otherDetailService: OtherDetailService) {
    window['reCaptcha3Loaded'] = () => {

      this.isCaptchaLoaded = true;

      this.getToken(this.action).then(token => {
        //Pushing token to subscriber
        this.CaptchaTokenSubject.next(token);
      });
    };
  }

  public init(siteKey, action) {
    this.scriptId = +(new Date());
    return new Promise((resolve, reject) => {

      this.siteKey = siteKey;
      this.action = action;
      const script = document.createElement('script');
      script.innerHTML = '';
      script.src = this.captchaClientApiBaseUrl + `?render=${this.siteKey}&onload=reCaptcha3Loaded`;
      script.id = `recapthcha-${this.scriptId}`;
      script.async = true;
      script.defer = true;
      script.onload = () => {
        resolve('success - postload');
      }
      script.onerror = () => {
        reject('error');
      };
      setTimeout(() => {
        document.head.appendChild(script);
      }, 2000);

      //if (this.isCaptchaLoaded) {
      //    resolve('success - preload');
      //    return;
      //}

    });
  }

  public getToken(action?: any): Promise<any> {
    return window['grecaptcha'].execute(this.siteKey, action);
  }

  public validateCaptchaToken(token: string) {
    return this.otherDetailService.validateCaptchaToken(token);
  }

  public hideCaptcha() {
    setTimeout(function () {
      //hide captcha icon
      var grecaptchaBadge = document.getElementsByClassName('grecaptcha-badge');
      if (grecaptchaBadge != null && grecaptchaBadge.length > 0)
        grecaptchaBadge[0].parentElement.hidden = true;
    }, 500);
  }
}
